import { lacks } from '@efdigital/ll-addon-auth';
import GeneralSection from '@efdigital/ll-admin-v2/components/client-edit/general-section.gts';
import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { EditRecord } from '@efdigital/ll-admin-v2/components/edit-record.gts';
import type { LibraryClientsEditModel } from '@efdigital/ll-admin-v2/routes/library/clients/client';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface Signature {
  Args: {
    model: LibraryClientsEditModel;
  };
}

const GeneralRoute: TemplateOnlyComponent<Signature> = <template>
  <EditContext as |context|>
    <EditRecord
      @editLabel="Edit Subscription"
      @item={{@model.client}}
      @context={{context}}
      @buttonSize="btn-md"
    >
      <:form as |uniqueId|>
        <GeneralSection
          @client={{@model.client}}
          @uniqueId={{uniqueId}}
          @isReadOnly={{lacks "clients" "editor"}}
        />
      </:form>
    </EditRecord>
  </EditContext>
</template>;

export default GeneralRoute;
